import { Feature } from 'ol';
import VectorSource from 'ol/source/Vector';
import { toPolygon } from './toPolygon';
const createVectorSourceFromObjects = source => {
  const sources = Array.isArray(source) ? source : [source];
  return new VectorSource({
    features: sources.filter(e => e.geom).map(feature => {
      const f = new Feature(toPolygon(feature));
      Object.entries(f.getGeometry().getProperties()).forEach(([key, value]) => f.set(`${key}`, value));
      return f;
    })
  });
};
export default createVectorSourceFromObjects;